import {FC} from "react";
import {ILog} from "../../types/ApiTypes";
import SpaceDetailsLogListItem from "./SpaceDetailsLogListItem";
import Card from "../ui/Card";
import {CgSpinner} from "react-icons/cg";

interface Props {
    logs: ILog[];
    loading: boolean;
}

const SpaceDetailsLogList: FC<Props> = (props) => {
    return (
      <Card title='Ablauf'>
          {!props.loading && (
            <ul className='space-y-4'>
                {props.logs.length <= 0 ? <li>Es gibt keine Abläufe für dieses Space</li> : (
                  props.logs.map(x => (
                    <SpaceDetailsLogListItem key={x.id} item={x}/>
                  ))
                )}
            </ul>
          )}
          {props.loading && (
            <CgSpinner className='animate-spin mx-auto text-5xl block'/>
          )}
      </Card>
    );
};

export default SpaceDetailsLogList;